import Joi from 'joi';

export default Joi.object({
	pay: Joi.number()
		.positive()
		.error(() => ({
			message: 'Čistá mzda musí být celé kladné číslo!',
		})),
	children: Joi.number()
		.min(0)
		.error(() => ({
			message: 'Vyplňte počet dětí jako číslo 0 - 10',
		})),
	type: Joi.any().allow([1, 2]),
	husband: Joi.any().allow([1, 2]),
});
